export default "__VITE_ASSET__CNancMsu__"